export const VALIDATION_MESSAGES = {
  no_dimensions: 'No dimensions added.',
  no_metrics: 'No metrics added.',
  cube_incomplete: 'Additional dimensions required.',
  no_dates: 'No dates selected',
  invalid_dates: 'You have selected an invalid date interval',
  incompatible_filters: 'At least one of your widgets isn’t compliant with its current combination of dimensions. Update dimensions in the widget or global filters to solve for empty widgets.'
};

export const DEFAULT_EXCLUDE_FALSY_TOOGLE = false;

export const DEFAULT_HEATMAP_STATUS = true;

export const EMPTY_FALSY_ERROR = 'All results were filtered out by the “Exclude N/A and 0 values” option.';

export const DEFAULT_INCLUDE_TOTALS = false;

export const DEFAULT_BENCHMARK_HEATMAP_TOOGLE = false;

export const DEFAULT_TAB_SPECIFIC_DATE = false;

export const FIRST_DAY_OF_WEEK_OPTIONS = [
  { value: '0', name: 'Sunday' },
  { value: '1', name: 'Monday' },
  { value: '2', name: 'Tuesday' },
  { value: '3', name: 'Wednesday' },
  { value: '4', name: 'Thursday' },
  { value: '5', name: 'Friday' },
  { value: '6', name: 'Saturday' },
];
